import(/* webpackMode: "eager", webpackExports: ["GoogleSignUpButton"] */ "/app/apps/sb-shell/app/(recaptcha)/sign-up/GoogleSignUpButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/app/(recaptcha)/sign-up/SignUpForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_babel-p_808d96c3bd2d3864059f0431583361bf/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_babel-p_808d96c3bd2d3864059f0431583361bf/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/core-events/src/search/SearchEventEmitter.tsx");
